import styled from 'styled-components';

export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
  
  .admin-center-profile {
    background-color: #1a1a1a;
    background-image: url("../../../../assets/images/maze-bacground.svg");
    width: 100%;
    height: 100%;
    padding: 1em 1em 3em 1em;
    margin-top: 5em;
    border-radius: 2px;
    display: flex;
    flex-direction: column; }
    
    .admin-profile-title,
    .admin-res-title {
      font: italic bold 24px "Roboto Condensed";
      margin-top: -1.25em;
      color: #fff;
      align-self: flex-start;
      text-transform: uppercase;
       }
    
    .admin-profile-holder {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        grid-template-rows: auto;
        grid-gap: 20px;
        align-items: center;
        justify-content: space-evenly; }
    
    .admin-summary-values {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%; }
        
    .admin-summary-values > button.learnmore {
          margin-top: 0.75em; }

    .detail-name {
        font-size: 14px;
      color:  #fff }

    .admin-home-graph {
          background-color: #1a1a1a;
          background-image: url("../../../assets/images/maze-bacground.svg");
          width: 100%;
          height: 100%;
          margin-top: 4em;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 2em 1em; }
        
    h2.admin-home-title{
          font: italic bold 24px "Roboto Condensed";
          color: #fff;
          margin-top: -2em;
          text-transform: uppercase;
          align-self: flex-start; }
`;

export const StyledSectionHeader = styled.h3`
  color: white;
  margin: 5px;
  margin-bottom: 23px;
`;

export const ContentRowSingleCol = styled.div`
  margin: 40px 0 65px;

  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }
`;


export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }
  
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;

  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
`;

export const ModalWrapper = styled.div`
  margin-top: 180px;

  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
`;

export const WidgetWrapper = styled.div`
  color: white;
  font-size: 16px;
  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
`;





// WEBPACK FOOTER //
// ./src/pages/Admin/Home/HomePage/HomePage.styles.ts